define('SessionKeepAlive.Controller', [
  'SessionKeepAlive.Settings',
  'jQuery'
], function (
  Settings,
  jQuery
) {
  'use strict';

  var STORAGE_PREFIX = 'uc_session_keepalive:';
  var LOGOUT_SELECTOR = '[data-touchpoint="logout"]';
  var ACTIVITY_EVENTS = 'click.ucSessionKeepAlive keydown.ucSessionKeepAlive touchstart.ucSessionKeepAlive';
  var NETSUITE_REQUEST = /\.ssp?(\?|#|$)/;
  var PING_REQUEST = /SessionKeepAlive\.Service\.ss/;

  function Store(customerId) {
    this.key = STORAGE_PREFIX + customerId;
    this.memory = null;
  }

  Store.prototype.read = function read() {
    try {
      var raw = window.localStorage.getItem(this.key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return this.memory;
    }
  };

  Store.prototype.write = function write(state) {
    this.memory = state;
    try {
      window.localStorage.setItem(this.key, JSON.stringify(state));
    } catch (e) {
      // Memory copy is enough for this tab.
    }
  };

  Store.prototype.clear = function clear() {
    this.memory = null;
    try {
      window.localStorage.removeItem(this.key);
    } catch (e) {
      // Nothing stored.
    }
  };

  function SessionKeepAliveController(options) {
    this.settings = options.settings;
    this.pingUrl = options.pingUrl;
    this.logoutUrl = options.logoutUrl;
    this.store = new Store(options.customerId);
    this.timer = null;
    this.lastInputAt = 0;
    this.lastPingAt = 0;
  }

  SessionKeepAliveController.prototype.start = function start() {
    var now = Date.now();
    var state = this.store.read();

    if (!state || !state.start || now - (state.lastRenew || 0) > Settings.NATIVE_IDLE_MS) {
      state = { start: now, lastRenew: now };
    } else {
      state.lastRenew = now;
    }
    this.store.write(state);
    this.lastPingAt = now;

    this.bindEvents();

    if (this.isPastMax(state, now)) {
      this.reachMax();
      return;
    }

    this.timer = window.setInterval(jQuery.proxy(this.tick, this, false), this.settings.pingIntervalMs);
  };

  SessionKeepAliveController.prototype.stop = function stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
    jQuery(document).off('.ucSessionKeepAlive');
  };

  SessionKeepAliveController.prototype.bindEvents = function bindEvents() {
    var self = this;

    jQuery(document).on('ajaxComplete.ucSessionKeepAlive', function (event, jqXhr, options) {
      var status = parseInt(jqXhr && jqXhr.status, 10);
      var url = options && options.url || '';
      if (status >= 200 && status < 300 && NETSUITE_REQUEST.test(url) && !PING_REQUEST.test(url)) {
        self.markRenewed();
      }
    });

    jQuery(document).on('click.ucSessionKeepAlive', LOGOUT_SELECTOR, function () {
      self.store.clear();
      self.stop();
    });

    jQuery(document).on('visibilitychange.ucSessionKeepAlive', function () {
      if (document.visibilityState === 'visible') {
        self.tick(true);
      }
    });

    if (this.settings.requireActivity) {
      jQuery(document).on(ACTIVITY_EVENTS, function () {
        self.lastInputAt = Date.now();
      });
      window.addEventListener('scroll', function () {
        self.lastInputAt = Date.now();
      }, { passive: true, capture: true });
    }
  };

  SessionKeepAliveController.prototype.markRenewed = function markRenewed() {
    var state = this.store.read();
    if (state) {
      state.lastRenew = Date.now();
      this.store.write(state);
    }
  };

  SessionKeepAliveController.prototype.isPastMax = function isPastMax(state, now) {
    return now - state.start >= this.settings.maxSessionMs;
  };

  SessionKeepAliveController.prototype.tick = function tick(onReturn) {
    var now = Date.now();
    var state = this.store.read();

    if (!state) {
      this.stop();
      return;
    }

    if (this.isPastMax(state, now)) {
      this.reachMax();
      return;
    }

    if (!onReturn && this.settings.requireActivity && this.lastInputAt <= this.lastPingAt) {
      return;
    }

    if (now - (state.lastRenew || 0) < this.settings.pingIntervalMs / 2) {
      return;
    }

    this.ping();
  };

  SessionKeepAliveController.prototype.ping = function ping() {
    var self = this;
    this.lastPingAt = Date.now();

    jQuery.ajax({
      url: this.pingUrl,
      type: 'GET',
      dataType: 'json',
      cache: false,
      beforeSend: function (jqXhr) {
        jqXhr.preventDefault = true;
      }
    }).done(function (data) {
      if (data && data.loggedIn === true) {
        self.markRenewed();
      }
    }).fail(function (jqXhr) {
      if (parseInt(jqXhr && jqXhr.status, 10) === 401) {
        self.stop();
      }
    });
  };

  SessionKeepAliveController.prototype.reachMax = function reachMax() {
    this.stop();
    if (this.settings.logoutAtMax && this.logoutUrl) {
      this.store.clear();
      window.location.href = this.logoutUrl;
    }
  };

  return SessionKeepAliveController;
});
